import { render, staticRenderFns } from "./TheUploadForm.vue?vue&type=template&id=0a0b2ca2&"
import script from "./TheUploadForm.vue?vue&type=script&lang=js&"
export * from "./TheUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./TheUploadForm.vue?vue&type=style&index=0&id=0a0b2ca2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports